$('.tego-autocomplete').each(function () {
    $(this).autocomplete({
        minLength: 0,
        minLengthReal: 2,
        seul: null,
        cache: {},
        source(request, response) {
            var cache = this.options.cache;
            var storage = this.element.attr('data-storage');
            var src = this.element.attr('data-src');

            request.term = Agpm.pregFormat(request.term);

            if (request.term.length < this.options.minLengthReal) {
                response({});
                return;
            }

            if (request.term in cache) {
                response(cache[request.term]);
                return;
            }

            if (storage == 'web') {
                $.post(src, request, function (data, status, xhr) {
                    cache[request.term] = data;
                    response(cache[request.term]);
                });
            } else {
                cache[request.term] = JSON.parse(src)
                response(cache[request.term]);
            }
        },
        response(event, ui) {
            $('#' + $(this).data('parent')).val('');
            if ($(this).data('required')) {
                event.target.setCustomValidity($(this).data('required'));
            }

            if (ui.content.length == 1) {
                this.seul = ui.content[0];
            } else {
                this.seul = null;
            }
        },
        focus(event, ui) {
            return false;
        },
        change(event, ui) {
            if (this.seul) {
                ui.item = this.seul;
                $(this).data('ui-autocomplete')._trigger('select', 'autocompleteselect', ui);
            }
        },
        select(event, ui) {
            $(this).val(ui.item.label);
            $('#' + $(this).data('parent')).val(ui.item.value).trigger('change');
            event.target.setCustomValidity('');
            return false;
        }
    }).data("ui-autocomplete")._renderItem = function (ul, item) {
        var term = Agpm.pregFormat(this.term);
        var text = String(item.label);
        var exp = new RegExp(term, 'gi');

        if (exp.test(text)) {
            var newText = text.replace(exp, '<span>$&</span>');
            return $("<li>")
                .data("item.ui-autocomplete", item)
                .append("<div>" + newText + "</div>")
                .appendTo(ul);
        }

        return $("<li>");
    };
});
